module.exports = __webpack_public_path__ + "static/P2101527-ecdf060627b7e6d333c7b1cbe2515cb5.jpg";